import React, { Component } from 'react';
import './HouseGridSelector.css';
import GenericWindow from '../window/GenericWindow';
import WindowEventNames from '../window/WindowEventNames';
import IconButtonNonReact from '../components/IconButtonNonReact';
import AssetsManager from '../assets_management/AssetsManager';
import Urls from '../urls/Urls';
import WindowType from '../enums/WindowType';
import HouseTypesViewerEntry from './HouseTypesViewerEntry';
import MenuType from '../enums/MenuType';
import ResizeWatchers from '../ui_core/ResizeWatchers';
import E from '../ui_core/E';
import Configuration from '../configuration/Configuration';
import HouseGridSelectorEntry from './HouseGridSelectorEntry';
import HouseGridSelectorInfo from './HouseGridSelectorInfo';
import HouseGridSelectorShowing from './HouseGridSelectorShowing';
export default class HouseTypesViewer {
	constructor(props){
		const {onSelectedOptionsChange, clearFilters, showMenu, showImagesFullScreen, showStreetView, 
		addFavourite, removeFavourite, enterHouse, configuration, showBrochureGenerationDialog} = props;
		this._configuration= configuration;
		this._showImagesFullScreen=showImagesFullScreen;
		this._showStreetView = showStreetView;
		this._setColumnsClass = this._setColumnsClass.bind(this);
		this._windowMinimized= this._windowMinimized.bind(this);
		this._clickedWindowClose = this._clickedWindowClose.bind(this);
		this._show = this._show.bind(this);
		this._callbackAddFavourite = addFavourite;
		this._callbackRemoveFavourite = removeFavourite;
		this._callbackSelectedOptionsChange=onSelectedOptionsChange;
		this._enterHouse = enterHouse;
		this._mapHouseTypeToEntry = new Map();
		
		const tooltipMessage=`${AssetsManager.configuration.siteName} - ${AssetsManager.configuration.companyAddressLine1}`;
		this._siteNameElement = E.div('site-name');
		console.log(Configuration);
		//this._siteNameElement.textContent = AssetsManager.configuration.siteName;
		this._locationElement = E.div('location');
		this._locationElement.textContent = AssetsManager.configuration.companyAddressLine1;
		
		this._window = new GenericWindow({tooltipMessage, name:' ',
			defaultX:0, defaultY:0, minimized:!
			configuration.showHouseTypesViewerOnOpen, 
			maximized:true, minimizable:false,
			maximizable:false, closeable:true, minimizeOnClose:true, resizable:false, dragable:false,
			callbackClickedClose:this._clickedWindowClose,
			type:WindowType.HOUSE_TYPE_VIEWER
		});
		this._tabElement = this._window.getTabElement();
		this._element = this._window.getElement();
		this._element.classList.add('house-grid-selector');
		this._innerElement =this._window.getMainElement();
		this._innerElement.classList.add('inner');
		this._innerTitleElement = E.div('inner-title');
		this._innerTitleElement.appendChild(this._siteNameElement);
		const seperator = E.div('seperator');
		seperator.textContent = ' - ';
		this._innerTitleElement.appendChild(seperator);
		this._innerTitleElement.appendChild(this._locationElement);
		this.initialize = this.initialize.bind(this);
		this._createEntries = this._createEntries.bind(this);
		this._clickedEntry = this._clickedEntry.bind(this);
		this._setShowing= this._setShowing.bind(this);
		this.show = this.show.bind(this);
		this.hide= this.hide.bind(this);
		this._handleResized = this._handleResized.bind(this);
		ResizeWatchers.add({element:this._element, onResized:this._handleResized,staggered:false});
		
		this._window.addEventListener(WindowEventNames.MINIMIZED, this._windowMinimized);
		this._entries = [];
		this._scrollableElement = document.createElement('div');
		this._scrollableElement.classList.add('scrollable');
		this._houseTypeEntriesElement = E.div('house-type-entries');
		this._scrollableElement.appendChild(this._houseTypeEntriesElement);
		this._houseTypeEntriesElement.appendChild(this._innerTitleElement);
		this._houseGridSelectorInfo = new HouseGridSelectorInfo({getWindowElement:()=>this._element, configuration:this._configuration, showBrochureGenerationDialog});
		this._innerElement.appendChild(this._scrollableElement);
		this._scrollableElement.appendChild(this._houseGridSelectorInfo.element);
		this._setShowing(HouseGridSelectorShowing.Entries);
		
	}
	initialize({siteJson, houseTypesViewModel}){
		this._siteJson = siteJson;
		this._createEntries(houseTypesViewModel);
	}
	_handleResized(){
		if(this._scrollableElement.offsetWidth<700){
			this._setColumnsClass('one-columns');
			return;
		}
		if(this._scrollableElement.offsetWidth<1050){
			this._setColumnsClass('two-columns');
			return;
		}
		if(this._scrollableElement.offsetWidth<1400){
			this._setColumnsClass('three-columns');
			return;
		}
		this._setColumnsClass('four-columns');
	}
	_setColumnsClass(className){
		if(this._currentColumnClassName)
			this._element.classList.remove(this._currentColumnClassName);
		this._element.classList.add(className);
		this._currentColumnClassName = className;
	}
	_createEntries(houseTypesViewModel){
	const mapNBedroomsToEntries = new Map();
		houseTypesViewModel.entries.forEach(houseTypeViewModel=>{
			const houseTypes =houseTypeViewModel.houseTypesWithSameName;
			let allHouseTypePlots = [];
			houseTypes.forEach(houseType=>allHouseTypePlots = allHouseTypePlots.concat(houseType.plots));
			if(allHouseTypePlots.length<1)return;
			const houseGridSelectorEntry = new HouseGridSelectorEntry({
				houseTypes,
				callbackClicked:this._clickedEntry,
				houseTypeViewModel,
				showImagesFullScreen:this._showImagesFullScreen,
				showStreetView:this._showStreetView,
				hide:this.hide,
				callbackAddFavourite:this._callbackAddFavourite,
				callbackRemoveFavourite:this._callbackRemoveFavourite,
				enterHouse:this._enterHouse,
				configuration:this._configuration
			});
			const nBedrooms = allHouseTypePlots[0].nBedrooms;
			let entriesNBedrooms = mapNBedroomsToEntries.get(nBedrooms);
			if(entriesNBedrooms){
				entriesNBedrooms.entries.push(houseGridSelectorEntry);
			}
			else{
				entriesNBedrooms = {entries:[houseGridSelectorEntry], nBedrooms};
				mapNBedroomsToEntries.set(nBedrooms, entriesNBedrooms);
			}
			this._entries.push(houseGridSelectorEntry);
			houseTypes.forEach(houseType=>
				this._mapHouseTypeToEntry.set(houseType, houseGridSelectorEntry)
			);
		});
		console.log('mapNBedrooms');
		console.log(mapNBedroomsToEntries);
		const nBedroomsAndEntries = Array.from(mapNBedroomsToEntries.values());
		nBedroomsAndEntries.sort((a, b)=>a.nBedrooms - b.nBedrooms);
		nBedroomsAndEntries.forEach(({nBedrooms, entries})=>{
			const divNBedrooms = E.div('n-bedrooms-grouping');
			const nBedroomsElement = E.div('n-bedrooms');
			nBedroomsElement.textContent=`${nBedrooms} Bedrooms`;
			divNBedrooms.appendChild(nBedroomsElement);
			entries.forEach(e=>divNBedrooms.appendChild(e.element));
			this._houseTypeEntriesElement.appendChild(divNBedrooms);
		});
	}
	_setShowing(value){
		if(this._currentlyShowingClassName){
			this._element.classList.remove(this._currentlyShowingClassName);
		}
		this._showing = value;
		this._currentlyShowingClassName = HouseGridSelectorShowing.getClassName(value);
		this._element.classList.add(this._currentlyShowingClassName);
		this._scrollableElement.scrollTop = 0;
	}
	_windowMinimized(){
		document.body.classList.remove('house-grid-selector-visible');
	}
	_clickedEntry(entry){
		this._setShowing(HouseGridSelectorShowing.Info);
		this._houseGridSelectorInfo.load(entry.houseType);
		this._scrollableElement.scrollTop = 0;
	}
	_clickedWindowClose(){
		if(this._showing===HouseGridSelectorShowing.Info){
			if(!this._wentDirectlyToInfo){
				this._setShowing(HouseGridSelectorShowing.Entries);
				return false;
			}
		}
		return true;
	}
	showInfo(){
		this._wentDirectlyToInfo = true;
		this._show();
	}
	show(){
		this._wentDirectlyToInfo=false;
		this._show();
	}
	_show(){
		document.body.classList.add('house-grid-selector-visible');
		this._window.unminimize();
		this._window.bringToFront();
		this._handleResized();
	}
	hide(){
		this._window.minimize();
	}
	get element(){
		return this._element;
	}
}
